import { FileText, Clock } from 'lucide-react';
import { SavedCoverpage } from '../../services/msdsCoverpageApi';

interface SavedCoverpagesListProps {
    coverpages: SavedCoverpage[];
    onLoad: (id: number) => void;
}

export function SavedCoverpagesList({ coverpages, onLoad }: SavedCoverpagesListProps) {
    if (coverpages.length === 0) {
        return (
            <p className="text-sm text-gray-500 italic py-4 text-center">
                No saved cover pages yet.
            </p>
        );
    }

    return (
        <div className="space-y-2 max-h-64 overflow-y-auto">
            {coverpages.map(cp => (
                <button
                    key={cp.Id}
                    onClick={() => onLoad(cp.Id)}
                    className="w-full flex items-center gap-3 p-3 rounded-lg border hover:bg-blue-50 hover:border-blue-200 transition-colors text-left"
                >
                    <FileText className="w-4 h-4 text-blue-600 flex-shrink-0" />
                    <div className="flex-1 min-w-0">
                        <p className="text-sm font-medium text-gray-800 truncate">{cp.TradeName}</p>
                        <div className="flex items-center gap-2 text-xs text-gray-500">
                            {cp.SdsVersion && <span>v{cp.SdsVersion}</span>}
                            <span className="flex items-center gap-1">
                                <Clock className="w-3 h-3" />
                                {new Date(cp.UpdatedAt).toLocaleDateString('de-CH')}
                            </span>
                        </div>
                    </div>
                    <span className="text-xs px-2 py-0.5 rounded bg-gray-100 text-gray-600">
                        {cp.Language}
                    </span>
                </button>
            ))}
        </div>
    );
}
